import { Navigate } from "react-router"
import { useCustomerType } from "../utils"
import { ACQUISITION_FORM_LINKS } from "../links"
import { assertUnreachable } from "../../../../../utils/types"
import { CustomerType } from "../../acquisitionForm/form/useAcquisitionFormSchema"
import { BusinessContactForm } from "./BusinessContactForm"
import { HouseholdContactForm } from "./HouseholdContactForm"
import { useProductParamMatch } from "../contractType/contractTypeForm.utils"

function getContactForm(customerType: CustomerType) {
  switch (customerType) {
    case "household":
      return HouseholdContactForm
    case "business":
      return BusinessContactForm
    default:
      return assertUnreachable(customerType)
  }
}

export function ContactPage() {
  const customerType = useCustomerType()
  const { productParamMatch, product } = useProductParamMatch(customerType ?? "household")

  if (!customerType) {
    return <Navigate to={`..${ACQUISITION_FORM_LINKS.CUSTOMER_TYPE}`} />
  }

  if (!product) {
    return <Navigate to={`..${ACQUISITION_FORM_LINKS.CONTRACT_TYPE(customerType)}`} />
  }

  if (!productParamMatch) {
    return <Navigate to={`..${ACQUISITION_FORM_LINKS.CONTACT(customerType, product)}`} />
  }

  const ContactForm = getContactForm(customerType)
  return <ContactForm />
}
